// GET_FTP_IMPORT_BATCHES_LIST

import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getFTPImportBatchesList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_FTP_IMPORT_BATCHES_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ FTPImportBatchesRepo.ts:12 ~ getFTPImportBatchesList ~ response:",
    response
  );
  return response?.data;
};


export const addFTPImportBatch = async (body?: Record<string, any>) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.SETTING.ADD_FTP_IMPORT_BATCH,
    body
  );
  return response?.data;
};

export const getFTPImportBatchById = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_FTP_IMPORT_BATCH_BY_ID,
    {params}
  );
  return response?.data;
};


export const updateFTPImportBatch = async (body?: Record<string, any>) => {
  const response = await axiosInstance.put(
    API_ENDPOINTS.SETTING.UPDATE_FTP_IMPORT_BATCH,
    body
  );
  return response?.data;
};

export const getFTPConfigList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_CONFIG,{params}
  );
  return response?.data;
};

export const getFTPConfigById = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_CONFIG_BY_ID,{params}
  );
  return response?.data;
};

export const updateFTPConfig = async (body?:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.FTP.UPDATE_FTP_CONFIG}`,body);
    return response.data;
}

export const addFTPConfig = async (body?:Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.FTP.ADD_FTP_CONFIG}`,body);
    return response.data;
}


export const getFTPExportBatchList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_EXPORT_BATCHES,{params}
  );
  return response?.data;
};

export const getFTPExportBatchById = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_EXPORT_BATCH_BY_ID,{params}
  );
  return response?.data;
};

export const updateFTPExportBatch = async (body?:Record<string,any>) => {
    let response = await axiosInstance.put(`${API_ENDPOINTS.FTP.UPDATE_FTP_EXPORT_BATCHES}`,body);
    return response.data;
}

export const addFTPExportBatch = async (body?:Record<string,any>) => {
    let response = await axiosInstance.post(`${API_ENDPOINTS.FTP.ADD_FTP_EXPORT_BATCHES}`,body);
    return response.data;
}